import { useCallback, useEffect, useMemo, useState } from 'react';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import Select from 'react-select';

import { APP_URL_PROFILE } from '../../../const';
import { fetchLocations, getBirthLocation } from '../../../store/slices/authSlice';
import { debounce } from '../../../utils/helper';
import { dropdownStyles } from './styles';
import styles from './styles.module.scss';

const AutocompliteInput = ({ defaultValue, control, name, setValue = () => {}, isInProfile = false, placeholder = '' }) => {
    const dispatch = useDispatch();
    const { loading, list } = useSelector(getBirthLocation);
    const [normalisedList, setNormalisedList] = useState([]);
    const { t } = useTranslation();
    const { pathname } = useLocation();

    const onInputFetch = debounce((value) => {
        if (!value) {
            return;
        }
        dispatch(fetchLocations(value)).then();
    }, 500);

    const onSelectChange = (selectedOption) => {
        setValue(name, selectedOption);
    };

    useEffect(() => {
        const data = list.map((item) => ({
            value: item?.placeId,
            label: item?.description
        }));
        setNormalisedList(data);
    }, [list]);

    const NoOptionsMessage = useCallback(() => <div className={styles.noOption}>{t('labels.noOption')}</div>, []);

    const defaultSelectValue = useMemo(() => {
        return defaultValue?.placeId ? { defaultValue: { value: defaultValue.placeId, label: defaultValue.description } } : {};
    }, [defaultValue]);

    const selectorStyle = dropdownStyles(pathname === `/${APP_URL_PROFILE}`);

    return (
        <div className={styles.wrapper}>
            <Controller
                control={control}
                name={name}
                rules={{
                    required: {
                        value: isInProfile,
                        message: t('errors.birthPlace')
                    }
                }}
                {...defaultSelectValue}
                render={({ field }) => (
                    <Select
                        {...field}
                        options={normalisedList}
                        onInputChange={onInputFetch}
                        isLoading={!!loading}
                        isClearable={true}
                        onChange={onSelectChange}
                        styles={selectorStyle}
                        noOptionsMessage={NoOptionsMessage}
                        placeholder={placeholder}
                    />
                )}
            />
        </div>
    );
};

export default AutocompliteInput;
